module.exports = {
    extends: [
        '/',
        'base',
        'modal',
        'modal',
    ],

    handlers: [
        {
            name: 'onSuccessfulLoginDialog',
            async handle(callerComponent){
                if(!this.hasClass('container_templates_login_container')){
                    await this.show(true)
                }
            }
        }
    ]
}
